<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">{{ adminText('organizationAll.update_ticket_type_5e69ea4a', 'Update Ticket Type') }}</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <text-field v-model.trim="form.name" :label="adminText('organizationAll.ticket_type_name_e7fcbe84', 'Ticket Type name*')" type="text" />
      <div class="input-container">
        <text-field v-model.number="form.price" :label="adminText('organizationAll.price_eur_444903ee', 'Price (EUR)*')" type="number" />
      </div>
      <div class="input-container">
        <select-field
          v-model.number="form.venueId"
          :label="adminText('organizationAll.odeum_c0168cb9', 'Odeum')"
          :placeholder="adminText('organizationAll.select_odeum_285e8a6d', 'Select odeum')"
          style="width: 100%"
          :items="organizationVenues"
          item-render="name"
          item-select="id"
          @change="
            form.venueSection = []
            getSectorNames()
          "
        />
        <select-field-multiple
          v-if="numberOfVenueSectors > 1"
          v-model="form.venueSection"
          style="width: 100%"
          :items="sectorItems"
          :placeholder="adminText('organizationAll.select_sector_9a958a42', 'Select sector')"
          :label="adminText('organizationAll.sector_39fd2070', 'Sector')"
          item-render="text"
          item-select="value"
        />
      </div>
      <v-checkbox
        v-model="form.ticketSeller"
        :disabled="form.prepaidCoupon || form.membership"
        :label="adminText('organizationAll.do_not_display_on_the_web_store_this_ticket_t_8267608b', 'Do not display on the web store – This ticket type is available at the box office.')"
      />
      <v-checkbox
        v-model="form.isAccessible"
        disabled
      >
        <template v-slot:label>
          <span class="accessible-ticket-label">
            {{ adminText('organizationAll.accessible_ticket_for_persons_with_disabiliti_bfecfcdb', 'Accessible ticket (for persons with disabilities)') }}
            <img
              class="accessible-ticket-icon"
              :src="require('../../../assets/accessible-seat.svg')"
              alt=""
            >
          </span>
        </template>
      </v-checkbox>
      <v-checkbox
        v-model="form.salesChannel"
        :disabled="form.prepaidCoupon || form.membership"
        :label="adminText('organizationAll.available_for_ticket_sellers_this_ticket_type_cbee0506', 'Available for ticket sellers – This ticket type is visible to designated ticket sellers, defined for each performance.')"
      />
      <v-checkbox
        v-model="form.membership"
        :disabled="form.prepaidCoupon || form.ticketSeller || form.salesChannel"
        :label="adminText('organizationAll.membership_only_this_ticket_type_will_be_avai_5a35d92b', 'Membership only – This ticket type will be available only if connected to a specific membership plan')"
      />
      <v-checkbox
        v-model="form.prepaidCoupon"
        :disabled="form.ticketSeller || form.membership || form.salesChannel"
        :label="adminText('organizationAll.ticket_package_can_be_applied_39052788', 'Ticket package can be applied.')"
      />
      <p v-if="isArchived" class="archived-hint">
        {{ adminText('organizationAll.this_ticket_type_is_archived_it_stays_on_the__b5e50fdb', 'This ticket type is archived. It stays on the events that already use it, but cannot be added to new events or membership plans.') }}
      </p>
      <div class="buttons">
        <main-button
          v-if="isArchived"
          class="delete-button"
          flat
          :text="adminText('organizationAll.unarchive_1c639a48', 'UNARCHIVE')"
          @click="$emit('unarchiveTicketType', form.id)"
        />
        <main-button
          v-else-if="isSoldOut()"
          class="delete-button"
          color="error"
          flat
          :text="adminText('organizationAll.archive_0468a5b7', 'ARCHIVE')"
          @click="openArchiveConfirmation()"
        />
        <main-button
          v-else
          class="delete-button"
          color="error"
          flat
          :text="adminText('organizationAll.delete_d6f56360', 'DELETE')"
          @click="openDeleteConfirmation()"
        />
        <div class="buttons-right">
          <main-button
            class="update-btn"
            :text="adminText('organizationAll.update_52c6c181', 'UPDATE')"
            @click="$emit('updateTicketInfo', form)"
          />
        </div>
      </div>
    </div>
    <div v-if="confirmation.show" class="confirmation-layer">
      <div class="confirmation">
        <h2 class="confirmation-title">{{ organizationText(confirmation.title) }}</h2>
        <p class="confirmation-content">{{ organizationText(confirmation.content) }}</p>
        <div class="confirmation-buttons">
          <main-button :text="adminText('organizationAll.cancel_77dfd213', 'Cancel')" flat outline @click="confirmation.show = false" />
          <main-button
            :text="organizationText(confirmation.actionMessage)"
            color="error"
            @click="
              confirmation.action()
              confirmation.show = false
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

export default {
  mixins: [OrganizationLocalization],
  name: 'ticket-type-update-modal',
  props: {
    organizationVenues: {
      type: Array,
      default: () => [],
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        ...this.initialValues,
      },
      numberOfVenueSectors: 0,
      confirmation: {
        show: false,
        title: '',
        content: '',
        actionMessage: '',
        action: () => {},
      },
    }
  },
  computed: {
    sectorItems() {
      const venue = this.organizationVenues.find(item => item.id == this.form.venueId) || {}
      const names = Object.keys(venue.predefinedSections || {})
      if (!names.length) return []

      return [{ text: this.organizationText('All'), value: 'All' }, ...names.map(name => ({ text: name, value: name }))]
    },
    isArchived() {
      return !!this.form.archivedAt
    },
  },
  mounted() {
    this.getSectorNames()
  },
  methods: {
    openArchiveConfirmation() {
      this.confirmation = {
        show: true,
        title: 'Archive ticket type',
        content: this.organizationMessage('organizationAll.value0_has_already_been_sold_so_it_cannot_be__855d0ee4', '{{value0}} has already been sold, so it cannot be deleted. Archiving hides it from this list and stops it being added to new events and membership plans. Events that already use it keep selling it, and all reports stay unchanged.', { value0: this.form.name }),
        actionMessage: 'Archive',
        action: () => this.$emit('archiveTicketType', this.form.id),
      }
    },
    openDeleteConfirmation() {
      this.confirmation = {
        show: true,
        title: 'Delete ticket type',
        content: this.organizationMessage('organizationAll.value0_has_no_sales_and_will_be_permanently_r_6780435c', '{{value0}} has no sales and will be permanently removed, together with the tickets created from it on every event that uses it. This cannot be undone.', { value0: this.form.name }),
        actionMessage: 'Delete',
        action: () => this.$emit('deleteTicketType', this.form.id),
      }
    },
    isSoldOut() {
      if (typeof this.form.hasSoldOrderItems === 'boolean') {
        return this.form.hasSoldOrderItems
      }

      return (this.form.orderItems || []).some(oi => parseInt(oi.quantity) !== oi.initialQuantity)
    },
    getSectorNames() {
      const selectedVenue =
        this.organizationVenues.find(venue => venue.id == this.form.venueId) || {}
      const allSelectedVenueSections = selectedVenue.predefinedSections || {}
      this.numberOfVenueSectors = Object.keys(allSelectedVenueSections).length
      if (this.numberOfVenueSectors === this.form.venueSection.length) {
        this.form.venueSection = ['All']
      }

      return this.numberOfVenueSectors ? ['All', ...Object.keys(allSelectedVenueSections)] : []
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  margin-bottom: 1.5rem;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.buttons {
  display: flex;
  align-items: center;
}
.confirmation-layer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00000050;
}
.confirmation {
  background-color: white;
  border-radius: 20px;
  padding: 2rem;
  width: 100%;
  max-width: 31.25rem;
}
.confirmation-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: -0.03em;
  color: #0277bd;
  margin-bottom: 1rem;
}
.confirmation-content {
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  color: #4a4a4a;
  margin-bottom: 1.5rem;
}
.confirmation-buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 0.75rem;
}
.archived-hint {
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  color: #979797;
  margin-bottom: 0.5rem;
}
.buttons-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-container {
  display: flex;
  align-items: center;
  width: 100%;
  column-gap: 1.5rem;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}

.accessible-ticket-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.accessible-ticket-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
</style>
